export default "__VITE_ASSET__8b63932b__"